<template>
	<modal v-model="isShowing" class="d-inline-block">
		<a class="ml-3" slot="label">
			{{ to('CHANGE_STORE') }}
		</a>
		<div v-if="isShowing" class="order-store-changer-modal">
			<h2>Välj butik</h2>
			<store-selector
				:value="selectedStoreId"
				:cartRows="order.rows"
				:stockMap="stockMap || {}"
				@input="updateSelectedStore"
			/>
			<div class="change-store-buttons">
				<text-button
					width="stretch"
					text="Avbryt"
					variant="secondary"
					@click="isShowing = false"
				/>
				<text-button
					width="stretch"
					:text="'Ändra till ' + storeName"
					@click="commit"
				/>
			</div>
			<div class="clearfix" />
		</div>
	</modal>
</template>

<script>
import waja from 'waja';
import bus from 'eventbus';
import { t, storeName } from 'datastore/i18n';

export default {
	props: {
		order: {
			type: Object,
			required: true,
		},
		secret: {
			type: String,
			default: null,
		},
	},
	data () {
		return {
			isShowing: false, stockMap: null,
			selectedStoreId: null,
		};
	},
	methods: {
		to: t.prefix('ORDER'),
		updateSelectedStore (val) {
			this.selectedStoreId = val;
		},
		commit () {
			const text =
			  	'Är du säker på att du vill byta utlämningsställe till '+storeName(this.selectedStoreId)+'?<br>' +
				'Du blir av med eventuell köplats vid byte.<br>' +
				'Observera att det endast går att byta utlämningsställe en gång, därefter krävs att du kontaktar kundtjänst.';
			this.isShowing = false;
			bus.$emit('modal.confirm', text, () => {
				this.$emit('update:store', this.selectedStoreId);
			}, null, 'Ändra till ' + storeName(this.selectedStoreId), 'Avbryt', true);
		},
	},
	computed: {
		storeName () {
			return storeName(this.selectedStoreId);
		},
	},
	watch: {
		isShowing (isShowing) {
			if (! isShowing) {
				return;
			}
			this.selectedStoreId = this.order.store.id;
			if (! this.stockMap) {
				const req = waja.get('order/' + this.order.id + '/stock');

				if (this.secret) {
					req.data({ secret: this.secret });
				}

				req.on('success', res => {
					this.stockMap = res.data.stockMap;
				}).go();
			}
		},
	},
};
</script>
